// extracted by mini-css-extract-plugin
export default {"formGroup":"formGroup_formGroup__XJztw","formGroupCompact":"formGroup_formGroupCompact__+UPMJ"};